/* ============================================================
   Cofá – mobilmeny (förslag A), tyst "lägg i varukorg" och
   bekräftelse. Okt 2026. CSS: assets/cofa-menu-cart.css
   ============================================================ */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lang = (document.documentElement.lang || 'sv').slice(0, 2);
  var T = {
    sv: {
      menu: 'Meny', search: 'Sök kaffe, te, godis…', searchLabel: 'Sök i butiken',
      shop: 'Handla', more: 'Mer från Cofá', login: 'Logga in', account: 'Mitt konto',
      wish: 'Önskelista', added: 'Tillagd i varukorgen', view: 'Visa',
      // Brickan vid Kampanjer – ändra eller töm ('') när kampanjen är slut
      promo: 'Upp till −40 %'
    },
    en: {
      menu: 'Menu', search: 'Search coffee, tea, sweets…', searchLabel: 'Search the store',
      shop: 'Shop', more: 'More from Cofá', login: 'Log in', account: 'My account',
      wish: 'Wishlist', added: 'Added to cart', view: 'View', promo: 'Up to −40%'
    },
    ar: {
      menu: 'القائمة', search: 'ابحث عن القهوة والشاي والحلويات…', searchLabel: 'البحث في المتجر',
      shop: 'تسوق', more: 'المزيد من Cofá', login: 'تسجيل الدخول', account: 'حسابي',
      wish: 'قائمة الأمنيات', added: 'تمت الإضافة إلى السلة', view: 'عرض', promo: 'خصم حتى 40%'
    }
  };
  T = T[lang] || T.sv;

  function svg(paths, w) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (w || 1.6) +
      '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + paths + '</svg>';
  }
  var ICON = {
    cup: '<path d="M4 9h12v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V9z"/><path d="M16 11h1.5a2.5 2.5 0 0 1 0 5H16"/><path d="M8 3c0 1.5 1.5 1.5 1.5 3M12 3c0 1.5 1.5 1.5 1.5 3"/>',
    star: '<path d="M12 3l2.7 5.6 6.1.8-4.5 4.2 1.1 6.1L12 16.8 6.6 19.7l1.1-6.1L3.2 9.4l6.1-.8L12 3z"/>',
    fruit: '<path d="M12 8c4-2 8 0 7 5-1 4-4 7-7 7s-6-3-7-7c-1-5 3-7 7-5z"/><path d="M12 8c0-2 1-4 3-5M10 4c1 0 2 1 2 4"/>',
    sparkle: '<path d="M12 3v5M12 16v5M3 12h5M16 12h5M6 6l3 3M15 15l3 3M18 6l-3 3M9 15l-3 3"/>',
    candy: '<circle cx="12" cy="12" r="4"/><path d="M8.5 10L4 7v10l4.5-3M15.5 10L20 7v10l-4.5-3"/>',
    bar: '<rect x="6" y="3" width="12" height="18" rx="2"/><path d="M6 9h12M6 15h12M12 3v18"/>',
    tag: '<path d="M3 12V4h8l10 10-8 8L3 12z"/><circle cx="7.5" cy="7.5" r="1.5"/>',
    dot: '<circle cx="12" cy="12" r="3"/>',
    search: '<circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/>',
    user: '<circle cx="12" cy="8" r="4"/><path d="M4 21c1-4 4-6 8-6s7 2 8 6"/>',
    heart: '<path d="M12 20s-8-5-8-11a4.5 4.5 0 0 1 8-2.8A4.5 4.5 0 0 1 20 9c0 6-8 11-8 11z"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>'
  };
  // Ordningen spelar roll: första träffen vinner
  var MATCH = [
    [/kampanj|campaign|offer|sale|erbjud/, 'tag'],
    [/bastsalj|bestsell/, 'star'],
    [/frystork|freeze/, 'fruit'],
    [/vardagslyx|everyday|luxury/, 'sparkle'],
    [/godis|candy|sweet/, 'candy'],
    [/choklad|chocolate|notter|nuts/, 'bar'],
    [/kaffe|coffee|\/te\b|tea/, 'cup']
  ];
  function pickIcon(key) {
    for (var i = 0; i < MATCH.length; i++) if (MATCH[i][0].test(key)) return MATCH[i][1];
    return 'dot';
  }

  /* ---------------- Mobilmenyn ---------------- */
  function enhanceMenu() {
    var drawer = document.getElementById('menu-drawer');
    if (!drawer || drawer.hasAttribute('data-cofa')) return;
    drawer.setAttribute('data-cofa', '');
    var nav = drawer.querySelector('.menu-drawer__navigation');
    var list = nav && nav.querySelector('.menu-drawer__menu');
    if (!nav || !list) return;

    // Sökfält
    var form = document.createElement('form');
    form.className = 'cofa-msearch';
    form.action = root + 'search';
    form.method = 'get';
    form.setAttribute('role', 'search');
    form.innerHTML = svg(ICON.search, 1.8) +
      '<label class="visually-hidden" for="CofaMenuSearch">' + T.searchLabel + '</label>' +
      '<input id="CofaMenuSearch" type="search" name="q" autocomplete="off" enterkeyhint="search" placeholder="' + T.search + '">' +
      '<input type="hidden" name="options[prefix]" value="last">';
    nav.insertBefore(form, list);

    var label = document.createElement('p');
    label.className = 'cofa-mlabel';
    label.textContent = T.shop;
    nav.insertBefore(label, list);

    var firstSecondary = null;
    Array.prototype.forEach.call(list.children, function (li) {
      var item = li.querySelector(':scope > a.menu-drawer__menu-item, :scope > details > summary.menu-drawer__menu-item');
      if (!item) return;
      var hrefs = item.tagName === 'A'
        ? [item.getAttribute('href') || '']
        : Array.prototype.map.call(li.querySelectorAll('.menu-drawer__submenu a'), function (a) { return a.getAttribute('href') || ''; });
      var key = (hrefs.join(' ') + ' ' + (item.id || '')).toLowerCase();

      if (item.tagName === 'A' && /\/blogs\/|\/pages\/|\/products\/|presentkort|gift/.test(key)) {
        li.classList.add('cofa-mi--secondary');
        if (!firstSecondary) firstSecondary = li;
        return;
      }

      var name = pickIcon(key);
      var ico = document.createElement('span');
      ico.className = 'cofa-mi-ico';
      ico.innerHTML = svg(ICON[name]);
      item.insertBefore(ico, item.firstChild);

      if (name === 'tag') {
        item.classList.add('cofa-mi--promo');
        if (T.promo) {
          var pill = document.createElement('span');
          pill.className = 'cofa-mi-pill';
          pill.textContent = T.promo;
          item.appendChild(pill);
        }
      }
    });

    if (firstSecondary) {
      var more = document.createElement('li');
      more.className = 'cofa-mlabel';
      more.setAttribute('aria-hidden', 'true');
      more.textContent = T.more;
      list.insertBefore(more, firstSecondary);
    }

    // Konto + önskelista längst ned
    var util = drawer.querySelector('.menu-drawer__utility-links');
    if (util) {
      var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page;
      var loggedIn = !!(meta && meta.customerId);
      var box = document.createElement('div');
      box.className = 'cofa-macct';
      box.innerHTML = '<a href="' + root + 'account">' + svg(ICON.user, 1.5) + '<span>' + (loggedIn ? T.account : T.login) + '</span></a>';
      var wishHeader = document.querySelector('header xb-wishlist-header');
      if (wishHeader) {
        var b = document.createElement('button');
        b.type = 'button';
        b.innerHTML = svg(ICON.heart, 1.5) + '<span>' + T.wish + '</span>';
        b.addEventListener('click', function () {
          closeMenu();
          setTimeout(function () { wishHeader.click(); }, 250);
        });
        box.appendChild(b);
      }
      util.insertBefore(box, util.firstChild);
    }

    // "Meny" som rubrik i sidhuvudet + klass på body när menyn är öppen
    var header = document.querySelector('.section-header .header');
    if (header && !header.querySelector('.cofa-menu-title')) {
      var title = document.createElement('span');
      title.className = 'cofa-menu-title';
      title.setAttribute('aria-hidden', 'true');
      title.textContent = T.menu;
      header.appendChild(title);
    }
    var details = document.getElementById('Details-menu-drawer-container');
    if (details) {
      var sync = function () {
        document.body.classList.toggle('cofa-menu-open', details.classList.contains('menu-opening'));
      };
      new MutationObserver(sync).observe(details, { attributes: true, attributeFilter: ['class', 'open'] });
      sync();
    }
  }

  function closeMenu() {
    var hd = document.querySelector('header-drawer');
    var summary = hd && hd.querySelector('summary');
    if (hd && typeof hd.closeMenuDrawer === 'function') hd.closeMenuDrawer(new Event('cofa'), summary);
  }

  /* ---------------- Varukorgen ----------------
     Lådan öppnas bara när man trycker på varukorgsikonen.
     När något läggs i varukorgen visas en kort bekräftelse. */
  var toast, toastTimer;

  function hideToast() {
    if (toast) toast.classList.remove('is-on');
  }

  function bump() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('cofa-bump');
    void icon.offsetWidth;
    icon.classList.add('cofa-bump');
  }

  function showToast(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) return;
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cofa-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<img class="cofa-toast__img" alt="" width="44" height="44">' +
        '<div class="cofa-toast__txt"><strong>' + svg(ICON.check, 2.2) + '<span>' + T.added + '</span></strong>' +
        '<span class="cofa-toast__name"></span></div>' +
        '<button type="button" class="cofa-toast__btn">' + T.view + '</button>';
      document.body.appendChild(toast);
      toast.querySelector('.cofa-toast__btn').addEventListener('click', function () {
        hideToast();
        var d = document.querySelector('cart-drawer');
        if (d) d.open(document.getElementById('cart-icon-bubble'));
      });
      toast.addEventListener('pointerenter', function () { clearTimeout(toastTimer); });
      toast.addEventListener('pointerleave', function () { toastTimer = setTimeout(hideToast, 2000); });
    }
    var img = toast.querySelector('.cofa-toast__img');
    var src = state && (state.image || (state.featured_image && state.featured_image.url));
    if (src) {
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      img.hidden = false;
    } else {
      img.hidden = true;
    }
    toast.querySelector('.cofa-toast__name').textContent = (state && state.product_title) || '';

    var hdr = document.querySelector('.section-header');
    var top = hdr ? Math.max(8, Math.round(hdr.getBoundingClientRect().bottom) + 8) : 16;
    toast.style.setProperty('--cofa-toast-top', top + 'px');

    toast.classList.remove('is-on');
    void toast.offsetWidth;
    toast.classList.add('is-on');
    bump();
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 3800);
  }

  function patchCartDrawer() {
    var C = customElements.get('cart-drawer');
    if (!C || C.prototype.__cofaPatched) return;
    C.prototype.__cofaPatched = true;
    var open = C.prototype.open;
    var render = C.prototype.renderContents;
    C.prototype.open = function (by) {
      if (this.__cofaSilent) {
        this.__cofaSilent = false;
        return;
      }
      return open.call(this, by);
    };
    C.prototype.renderContents = function (state) {
      var self = this;
      var wasOpen = this.classList.contains('active');
      if (!wasOpen) this.__cofaSilent = true;
      render.call(this, state);
      setTimeout(function () { self.__cofaSilent = false; }, 300);
      if (!wasOpen) showToast(state);
    };
  }

  /* ---------------- Produktkort ----------------
     Ett tryck var som helst på bilden öppnar produkten
     (men inte hjärtat, varukorgsknappen eller andra knappar). */
  document.addEventListener('click', function (e) {
    var inner = e.target.closest && e.target.closest('.card-wrapper .card__inner');
    if (!inner) return;
    if (e.target.closest('a[href], button, input, label, select, textarea, [role="button"], [class*="xb-wishlist"], .quick-add, quick-add-modal')) return;
    var link = inner.closest('.card-wrapper').querySelector('.card__heading a[href]');
    if (!link) return;
    e.preventDefault();
    if (e.metaKey || e.ctrlKey) window.open(link.href, '_blank');
    else window.location.href = link.href;
  });

  function init() {
    enhanceMenu();
    if (window.customElements) {
      if (customElements.get('cart-drawer')) patchCartDrawer();
      else customElements.whenDefined('cart-drawer').then(patchCartDrawer);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
